import { ContentBlock } from "@/types";
import { createSecurityServiceContent } from "@/content/services/service-content-helpers";

export const content: ContentBlock[] = [
  ...createSecurityServiceContent({
    serviceName: "access control systems",
    summary:
      "Access control is useful when keys are too hard to manage or when different users need different access levels. Ozy Wide Group helps plan doors, readers, locks and permissions so the system suits the way staff, tenants, residents or contractors move through the site.",
    suitedTo: [
      "offices",
      "warehouses",
      "medical suites",
      "retail back-of-house areas",
      "strata entries",
      "restricted rooms",
    ],
    includes: [
      "card and fob systems",
      "keypad entry",
      "reader installation",
      "electric lock integration",
      "permission setup and changes",
    ],
    notes: [
      "door hardware",
      "fire egress",
      "staff roles",
      "after-hours access",
      "lost keys or fobs",
      "audit requirements",
    ],
    process: [
      "Identify the doors and areas that need controlled entry, including any emergency exit requirements.",
      "Match readers, controllers and locking hardware to the site conditions.",
      "Set up users and test access levels so the handover is clear and manageable.",
    ],
    faq: [
      "Access control can reduce the need to rekey a site when staff, tenants or contractors change.",
      "Door hardware, fire compliance and existing cabling affect the right installation method.",
      "Permissions should be reviewed whenever staff roles or tenancy arrangements change.",
    ],
  }),
];
